// Note: The first file of a module here, must also register the module

import "./activity-filter.model";
import "./appointment-filter.model";
import "./appointment.model";
import "./building.model";
import "./campaign.model";
import "./canvass-status.model";
import "./consent-type.model";
import "./custom-field-attachment.model";
import "./data-set.model";
import "./data-record.model";
import "./division.model";
import "./document.model";
import "./effort.model";
import "./event.model";
import "./feature.model";
import "./field.model";
import "./filter.model";
import "./group.model";
import "./house-occupant.model";
import "./house.model";
import "./invite.model";
import "./integration.model";
import "./issue.model";
import "./location.model";
import "./organisation-invite.model";
import "./organisation.model";
import "./privacy-notice.model";
import "./stat.model";
import "./street.model";
import "./survey-question.model";
import "./talking-point-category.model";
import "./talking-point.model";
import "./team.model";
import "./user.model";
